const state = {
    codeTax: 'caqb',
    activeTaxes: {

    }
}
const getters = {
    getCodeTax: () => {
        return state.codeTax
    },
    getActiveTaxes: () => {
        return state.activeTaxes
    }
}
const mutations = {
    changeCodeTax: (state, payload) => {
        state.codeTax = payload
    },
    changeActiveTaxes: (state, payload) => {
        state.activeTaxes = payload
    }
}
const actions = {
}

export default{
    state,
    mutations,
    getters,
    actions
}